/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState, useCallback } from 'react';
import { DataGridPro, GridActionsCellItem } from '@mui/x-data-grid-pro';
import apiAdmin from '../../services/api-admin';
import { MdEdit, MdDelete, MdAdd, MdContactPage, MdContentCopy, MdOutlinePictureAsPdf, MdLock } from 'react-icons/md';
import { useForm, Controller } from "react-hook-form";
import { TextField, ToggleButtonGroup, ToggleButton, MenuItem, Paper } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import {DateTime} from 'luxon';
import OutlinedDiv from '../layout/OutlinedDiv';
import { Editor } from 'react-draft-wysiwyg';
import './../styles/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import { convertToRaw, EditorState } from 'draft-js';
import ClassRegistrants from './class-registrations';
import fileDownload from 'js-file-download';
import { FormatHTMLForWYSIWYGEditor, blurOnEnterKey } from '../../services/utilities';
import SpinnerLoader from '../layout/spinner-loader';
import useWindowDimensions from '../../services/useWindowDimensions';
import { Dropzone } from "dropzone";
import "dropzone/dist/dropzone.css";
import { useOktaAuth } from '@okta/okta-react';
import CustomDataGridToolbar from '../layout/custom-toolbar';

const ClassesToolbar = ({ onAddNewClass, registrantSearch, onRegistrantSearchChange, classesListType, onClassesListTypeChange }) => {
    return (
        <CustomDataGridToolbar>
            <span className="btn-link btn" onClick={onAddNewClass}>
                <MdAdd className="mb-1"/> Add New Class
            </span>
            <div className="col-auto">
                <TextField
                    label="Registrant Search"
                    value={registrantSearch}
                    size="small"
                    onChange={onRegistrantSearchChange}
                />
            </div>
            <div className="col">
                <ToggleButtonGroup
                    className="float-end"
                    value={classesListType}
                    exclusive
                    onChange={onClassesListTypeChange}
                    aria-label="Upcoming or Past Toggle"
                    >
                        <ToggleButton value="upcoming" aria-label="Upcoming Classes">Upcoming Classes</ToggleButton>
                        <ToggleButton value="past" aria-label="Past Classes">Past Classes</ToggleButton>
                </ToggleButtonGroup>
            </div>
        </CustomDataGridToolbar>
    );
};

const Classes = (props) => {
    const { register, handleSubmit, setValue, reset, watch, formState: { errors }, control } = useForm({
        mode: 'onChange',
        defaultValues: {
            otherLocationName: ''
        }
    });
    const { authState } = useOktaAuth();
    const [classes, setClasses] = useState([]);
    const [classIdToEdit, setClassIdToEdit] = useState(null);
    const [classToEdit, setClassToEdit] = useState(null);
    const [classIdToDelete, setClassIdToDelete] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [deleted, setDeleted] = useState(false);
    const [error, setError] = useState(null);
    const [regions, setRegions] = useState([]);
    const [offices, setOffices] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState(1);
    const [selectedLocation, setSelectedLocation] = useState('Other');
    const [selectedClassState, setSelectedClassState] = useState('ID');
    const [selectedCertificateState, setSelectedCertificateState] = useState('ID');
    const [selectedCourseTopic, setSelectedCourseTopic] = useState('Real Estate Title');
    const [licenseStates, setLicenseStates] = useState([]);
    const [timeZone, setTimeZone] = useState('Mountain Time');
    const [emailNoteEditorState, setEmailNoteEditorState] = useState(
        () => EditorState.createEmpty(),
    )
    const [classRegistrantIdToDelete, setClassRegistrantIdToDelete] = useState(null);
    const [registrants, setRegistrants] = useState([]);
    const [registrantDeleted, setRegistrantDeleted] = useState(false);
    const [certificates, setCertificates] = useState(null);
    const [classCertificateId, setClassCertificateId] = useState(0);
    const [creatingCertificates, setCreatingCertificates] = useState(false);
    const [certificatesAlreadyEmailed, setCertificatesAlreadyEmailed] = useState(false);
    const [expandedRowIds, setExpandedRowIds] = useState(new Set());
    const [classesListType, setClassesListType] = useState('upcoming');
    const [classesToShow, setClassesToShow] = useState([]);
    const { width } = useWindowDimensions();
    const [fileDropzone, setFileDropzone] = useState(null);
    const [relatedDocs, setRelatedDocs] = useState([]);
    const [gettingRelatedDocs, setGettingRelatedDocs] = useState(false);
    const [loadingClasses, setLoadingClasses] = useState(true);
    const [relatedDocsId, setRelatedDocsId] = useState(0);
    const [registrantSearch, setRegistrantSearch] = useState('');
    const [registrantClassIds, setRegistrantClassIds] = useState(null);
    const [registrantSearchLoading, setRegistrantSearchLoading] = useState(false);
    const [filterModel, setFilterModel] = useState();
    const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    const requireLicense = watch("requireRealEstateLicenseNum");

    const columns = [
        { field: 'className', headerName: 'Class Name', flex: 600 },
        { field: 'private', headerName: '', flex: 25, renderCell: function (t) { return t.value ? <MdLock/> : <></>} },
        { field: 'location', headerName: 'Location', flex: 150 },
        { field: 'classDate', type: 'dateTime', headerName: 'Class Date', flex: 175, renderCell: function (t) { return t.value.toLocaleDateString("en-US", dateOptions)} },

        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 180,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                const actions = [];

                if (props.brandId !== 3) {
                    actions.push(
                        <GridActionsCellItem
                            icon={<MdContactPage title="Related Documents" />}
                            label="Related Documents"
                            onClick={() => { getRelatedDocs(id); setRelatedDocsId(id); }}
                            color="inherit"
                            data-bs-toggle="modal"
                            data-bs-target="#relatedDocsModal"
                            role="button"
                        />,
                        <GridActionsCellItem
                            icon={<MdOutlinePictureAsPdf title="Certificates" />}
                            label="Certificates"
                            onClick={() => { getCertificates(id); setClassCertificateId(id); }}
                            color="inherit"
                            data-bs-toggle="modal"
                            data-bs-target="#certificateModal"
                            role="button"
                        />
                    );
                }

                actions.push(
                    <GridActionsCellItem
                        icon={<MdContentCopy title="Copy" />}
                        label="Copy"
                        onClick={() => { copyClass(id); }}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<MdEdit title="Edit" />}
                        label="Edit"
                        onClick={() => { setClassIdToEdit(id); }}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<MdDelete title="Delete" />}
                        label="Delete"
                        onClick={() => { setClassIdToDelete(id); setDeleted(false); }}
                        color="inherit"
                        data-bs-toggle="modal"
                        data-bs-target="#deleteModal"
                        role="button"
                    />
                );

                return actions;
            }
        }
    ];
    if (props.brandId !== 3) {
        columns.splice(4, 0, { field: 'registrantCount', headerName: 'How Many', flex: 150 });
    }

    const getRelatedDocs = id => {
        setGettingRelatedDocs(true);
        if (fileDropzone) fileDropzone.disable();
        setFileDropzone(new Dropzone("div#file", { url: process.env.REACT_APP_API_ADMIN_BASE_URL + "/upload-related-class-document?classId=" + id,  maxFilesize: 15, headers: {'Authorization': `Bearer ${authState?.accessToken?.accessToken}` } }));
        const getDocs = async () => {
            apiAdmin.get(`/class-related-documents?classId=${id}`)
                .then((response) => {
                    setRelatedDocs(response.data);
                    setGettingRelatedDocs(false);
                });
        }
        getDocs();
    }

    const downloadSignInSheet = id => {
        const download = async () => {
            apiAdmin.get(`/class-sign-in-sheet?classId=${id}`, { responseType: 'blob' })
                .then((response) => {
                    fileDownload(response.data, 'SignInSheet.pdf');
                });
        }
        download();

    }

    const getCertificates = id => {
        const getCerts = async () => {
            apiAdmin.get(`/class-certificates?classId=${id}`)
                .then((response) => {
                    setCertificates(response.data);
                });
        }
        getCerts();

        const getClass = async () => {
            apiAdmin.get(`/class?classId=${id}`)
                .then((response) => {
                    setCertificatesAlreadyEmailed(response.data.certificatesEmailed)
                })
        }
        getClass();
    }

    const createCertificates = id => {
        if (!id || id === 0) return;
        setCreatingCertificates(true);
        const createCerts = async () => {
            apiAdmin.get(`/create-class-certificates?classId=${id}`)
                .then((response) => {
                    setCreatingCertificates(false);
                    getCertificates(id);
                });
        }
        createCerts();

    }

    const emailCertificates = id => {
        if (!id || id === 0) return;
        setCreatingCertificates(true);
        const emailCerts = async () => {
            apiAdmin.get(`/email-class-certificates?classId=${id}`)
                .then((response) => {
                    setCreatingCertificates(false);
                    getCertificates(id);
                });
        }
        emailCerts();
    }

    const downloadCertificates = id => {
        if (!id || id === 0) return;
        setCreatingCertificates(true);
        const downloadCerts = async () => {
            apiAdmin.get(`/download-class-certificates?classId=${id}`, {responseType: 'blob'})
                .then((response) => {
                    fileDownload(response.data, `ClassCertificates.pdf`);
                    setCreatingCertificates(false);
                    getCertificates(id);
                });
        }
        downloadCerts();
    }

    const deleteRegistrant = () => {
        const deleteFunc = async () => {
            await apiAdmin.post(`/delete-registrant?classRegistrationId=`+ classRegistrantIdToDelete)
                .then((response) => {
                    if (response.statusText === "OK") {
                        setClassRegistrantIdToDelete(null);
                        setRegistrantDeleted(true);
                    } else { 
                        setError("There was an error deleting the registrant. Please try again.")
                    }
                });
        }
        deleteFunc();
    }

    useEffect(() => {
        const getClasses = async () => {
            apiAdmin.get(`/classes?brandId=${props.brandId}`)
                .then((response) => {
                    setClasses(response.data.map((a) => ({ 
                        id: a.classId, 
                        className: a.className, 
                        private: a.isPrivate,
                        location: a.locationCity + (a.classState ? ', ' + a.classState : ''), 
                        classDateISO: a.classDate, 
                        requireLicense: a.requireRealEstateLicenseNum, 
                        registrantCount: a.maxRegistrants ? a.registrantCount + ' of ' + a.maxRegistrants : a.registrantCount, 
                        classDate: new Date(a.classDate),
                        regionId: a.regionId 
                    })));

                });
        }

        getClasses();

        const getRegions = async () => {
            apiAdmin.get(`/regions`)
                .then((response) => {
                    setRegions(response.data);
                });
        }
        getRegions();

        const getOffices = async () => {
            apiAdmin.get(`/offices`)
                .then((response) => {
                    setOffices(response.data);                    
                });
        }

        getOffices();

    }, [submitted, deleted, props.brandId]);

    useEffect(() => {
        const baseClasses = classesListType === 'upcoming'
            ? classes.filter(c => DateTime.fromISO(c.classDateISO) > DateTime.now().minus({ days: 7 }))
            : classes.filter(c => DateTime.fromISO(c.classDateISO) <= DateTime.now().minus({ days: 7 }))
                .sort((a, b) => DateTime.fromISO(b.classDateISO).diff(DateTime.fromISO(a.classDateISO)));

        if (registrantSearch.trim()) {
            const classIdSet = new Set(registrantClassIds ?? []);
            setClassesToShow(baseClasses.filter(c => classIdSet.has(c.id)));
        } else {
            setClassesToShow(baseClasses);
        }
        setLoadingClasses(false);
    }, [classes, classesListType, registrantSearch, registrantClassIds]);

    useEffect(() => {
        const trimmedSearch = registrantSearch.trim();
        if (!trimmedSearch) {
            setRegistrantClassIds(null);
            setRegistrantSearchLoading(false);
            return;
        }

        setRegistrantSearchLoading(true);
        const timeoutId = setTimeout(() => {
            apiAdmin.get(`/class-registrant-search?brandId=${props.brandId}&query=${encodeURIComponent(trimmedSearch)}`)
                .then((response) => {
                    setRegistrantClassIds(response.data);
                    setRegistrantSearchLoading(false);
                })
                .catch(() => {
                    setRegistrantClassIds([]);
                    setRegistrantSearchLoading(false);
                });
        }, 400);

        return () => clearTimeout(timeoutId);
    }, [registrantSearch, props.brandId]);

    useEffect(() => {
        if (!classIdToEdit || classIdToEdit === -1) return;
        const getClass = async () => {
            apiAdmin.get(`/class?classId=${classIdToEdit}`)
                .then((response) => {
                    setClassToEdit(response.data);
                    Object.keys(response.data).forEach(function (key, index) {
                        setValue(key, response.data[key]);
                    });    
                    setLicenseStates(response.data.licenseState?.split(',') || []);
                    var classDate = DateTime.fromFormat(response.data.classDate.split('T')[0] + ' ' + response.data.classTime, 'yyyy-MM-dd t');
                    var classDateEnd = DateTime.fromFormat(response.data.classDateEnd.split('T')[0] + ' ' + response.data.classEndTime, 'yyyy-MM-dd t');
                    setValue('classDate', classDate);
                    setValue('classDateEnd', classDateEnd);
                    setTimeZone(response.data.timeZone);
                    var locationParts = response.data.location.split('<br />');
                    var location = offices.find(o => o.officeName === locationParts[0]);
                    setSelectedLocation(location ? location.officeName : 'Other');
                    setSelectedCourseTopic(response.data.courseTopic);
                    setSelectedCertificateState(response.data.certificateState || 'ID');

                    if (response.data.isRemote && props.brandId === 3) {
                        setSelectedRegion('real1031REMOTE');
                        setValue('otherLocationName', response.data.location);
                    } else if (response.data.isRemote) {
                        setSelectedRegion('REMOTE');
                        setValue('otherLocationName', response.data.location);
                    } else { 
                        setSelectedRegion(response.data.regionId ?? 'REMOTE');
                        if (!location) { 
                            setValue('otherLocationName', locationParts[0]);
                            if (locationParts.length > 1) {
                                setValue('otherLocationAddress', locationParts[1]);
                                setValue('otherLocationCity', locationParts[2].split(',')[0]);
                                setValue('otherLocationState', locationParts[2].split(', ')[1].split(' ')[0]);
                                setValue('otherLocationZip', locationParts[2].split(', ')[1].split(' ')[1]);
                            }
                        }
                    }
                });
        }
        getClass();
    }, [classIdToEdit]);
   
    useEffect(() => {
        if (classToEdit || classIdToEdit === -1) {
            setSubmitted(false);
            if (classToEdit) {
                setEmailNoteEditorState(FormatHTMLForWYSIWYGEditor(classToEdit.confirmationEmailNote));  
            } else { 
                setEmailNoteEditorState(EditorState.createEmpty());
            }
        }
    }, [classToEdit, classIdToEdit]);

    useEffect(() => {
        if (selectedRegion === 'REMOTE' && classIdToEdit === -1) {
            setValue('otherLocationName', 'This is a remote class. Please see confirmation email for instructions on how to join.')
        }
    }, [selectedRegion]);
    const handleAddNewClass = useCallback(() => {
        setClassIdToEdit(-1);
    }, []);

    const handleRegistrantSearchChange = useCallback((event) => {
        setRegistrantSearch(event.target.value);
    }, []);

    const handleClassesListTypeChange = useCallback((event, newType) => {
        if (newType) {
            setClassesListType(newType);
        }
    }, []);

    const onSubmit = data => {
        setLoadingClasses(true);
        if (selectedRegion === 'real1031REMOTE' && props.brandId === 3) {
            data.locationCity = 'Real1031 REMOTE';
            data.location = data.otherLocationName;
            data.isRemote = true;
            data.regionId = 10;
        } else if (selectedRegion === 'REMOTE') {
            data.locationCity = 'REMOTE';
            data.location = data.otherLocationName;
            data.classState = selectedClassState;
            data.isRemote = true;
            data.regionId = null;
        } else if (selectedLocation === 'Other') {
            data.location = `${data.otherLocationName}<br />${data.otherLocationAddress}<br />${data.otherLocationCity}, ${data.otherLocationState} ${data.otherLocationZip}<br />`;
            data.locationCity = data.otherLocationCity;
            data.classState = data.otherLocationState;
            data.regionId = selectedRegion;
            data.isRemote = false;
        } else { 
            var office = offices.find(o => o.officeName === selectedLocation);
            data.location = `${office.officeName}<br />${office.address1}<br />${office.city}, ${office.stateAbbrev} ${office.zip}<br />`;
            data.locationCity = office.city;
            data.classState = office.stateAbbrev;
            data.regionId = selectedRegion;
            data.isRemote = false;
        }

        if (props.brandId === 3 && !data.notificationEmail) {
            data.notificationEmail = "exchange@realexchange1031.com";
        }

        const classObject = {
            ...data,
            classId: classIdToEdit,
            className: data.className.trimEnd(),
            classTime: data.classDate.toFormat('t'),
            classEndTime: data.classDateEnd.toFormat('t'),
            timeZone: timeZone,
            confirmationEmailNote: draftToHtml(convertToRaw(emailNoteEditorState.getCurrentContent())),
            contEdCredits: data.contEdCredits === '' ? 0 : data.contEdCredits,
            fee: data.fee === '' ? 0 : data.fee,
            courseTopic: selectedCourseTopic,
            licenseState: licenseStates.filter(Boolean).join(','),
            certificateState: selectedCertificateState
        }

        const saveClass = async () => {
            await apiAdmin.post(`/save-class`, classObject)
                .then((response) => {
                    if (response.data) {
                        setClassIdToEdit(null);
                        setClassToEdit(null);
                        setSubmitted(true);
                        setSelectedLocation('Other');
                        setSelectedRegion(1);
                        setTimeZone('Mountain Time');
                        setSelectedCourseTopic('Real Estate Title');
                        setSelectedCertificateState('ID');
                        reset();
                        window.scrollTo(0, 0);
                    } else { 
                        setError("There was an error saving the class. Please try again.")
                    }
                });
        }
        saveClass();
    }

    const copyClass = id => {
        setSubmitted(false);
        setLoadingClasses(true);
        const getClass = async () => {
            apiAdmin.get(`/class?classId=${id}`)
                .then((response) => {
                    const saveClass = async () => {
                        response.data.classId = -1;
                        response.data.className = response.data.className + ' (COPY)'
                        await apiAdmin.post(`/save-class`, response.data)
                            .then((response) => {
                                if (response.data) {
                                    setSubmitted(true);
                                    reset();
                                } else { 
                                    setError("There was an error copying the class. Please try again.")
                                }
                            });
                    }
                    saveClass();
                });
        }
        getClass();

    }

    const deleteClass = () => {
        setLoadingClasses(true);
        const deleteMessage = async () => {
            await apiAdmin.post(`/delete-class?classId=`+ classIdToDelete)
                .then((response) => {
                    if (response.statusText === "OK") {
                        setClassIdToDelete(null);
                        setDeleted(true);
                    } else { 
                        setError("There was an error deleting the class. Please try again.")
                    }
                });
        }
        deleteMessage();
    }

    const deleteDocument = (document) => {
        const deleteDoc = async () => {
            await apiAdmin.post(`/delete-related-class-document?classId=`+ classIdToDelete + '&fileName=' + encodeURIComponent(document))
                .then((response) => {
                    if (response.statusText === "OK") {
                        setRelatedDocs(relatedDocs.filter(f => f !== document));
                    } else { 
                        setError("There was an error deleting the document. Please try again.")
                    }
                });
        }
        deleteDoc();
    }

    function DetailPanelContent({ row: rowProp }) {
        return (
            <Paper className="p-3">
                <ClassRegistrants classToEdit={classes.find(c => c.id === rowProp.id)} classes={classes} classId={rowProp.id} registrants={registrants} setRegistrants={setRegistrants} setClassRegistrantIdToDelete={setClassRegistrantIdToDelete} registrantDeleted={registrantDeleted} setRegistrantDeleted={setRegistrantDeleted} />
            </Paper>
        )    
    }

    const handleDetailPanelExpandedRowIdsChange = useCallback((newIds) => {
        setExpandedRowIds(newIds.length > 1 ? new Set([newIds[newIds.length - 1]]) : new Set(newIds),);
      }, []);

    const handleFilterModelChange = useCallback((newModel) => {
        setFilterModel(newModel);
    }, []);

    return (
        <div>
            <title>Classes</title>
            <h1>Classes</h1>
            {classToEdit || classIdToEdit === -1 ? <>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="border p-3">
                        {classToEdit && classToEdit.isPrivate && <div className="mb-3">
                            <TextField
                                label="Class URL"
                                value={"https://www.titleonecorp.com/classes/" + classIdToEdit}
                                className="w-100"
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                                />
                            {errors?.className?.type === "required" && <small className="text-danger">This field is required</small>}
                        </div>

                        }
                        <div className="mb-3">
                            <TextField
                                label="Class Name *"
                                {...register("className", {required: true})}
                                className="w-100"
                            />
                            {errors?.className?.type === "required" && <small className="text-danger">This field is required</small>}
                        </div>
                        <div className="mb-3">
                            <TextField
                                label="Instructor Name and License # for WA and MT *"
                                {...register("instructorName", { required: true })}
                                className="w-100"
                                inputProps={{ maxLength: 50} }
                            />
                            {errors?.instructorName?.type === "required" && <small className="text-danger">This field is required</small>}
                        </div>
                        <div className="mb-3">
                            <TextField
                                label="Course Approval Number *"
                                {...register("courseApprovalNum", {
                                    required: true,
                                    pattern: /^[a-zA-Z0-9-]+$/
                                })}
                                className="w-100"
                            />
                            {errors?.courseApprovalNum?.type === "required" && <small className="text-danger">This field is required</small>}
                            {errors?.courseApprovalNum?.type === "pattern" && <small className="text-danger">Only letters, numbers and hyphens are allowed</small>}
                        </div>
                        <div className="mb-3 row">
                            <div className="col-md-4 col-6">
                                <Controller
                                    name="classDate"
                                    control={control}
                                    rules={{required: true}}
                                    render={({ field: { onChange, value } }) => (
                                        <DateTimePicker  value={value} onChange={onChange} className="w-100" label="Start Date/Time"/>
                                    )}
                                />
                                {errors?.classDate?.type === "required" && <small className="text-danger">This field is required</small>}
                            </div>
                            <div className="col-md-4 col-6">
                                <Controller
                                    name="classDateEnd"
                                    control={control}
                                    rules={{required: true}}
                                   render={({ field: { onChange, value } }) => (
                                        <DateTimePicker  value={value} onChange={onChange} className="w-100" label="End Date/Time"/>
                                    )}
                                />
                                {errors?.classDateEnd?.type === "required" && <small className="text-danger">This field is required</small>}
                            </div>
                            <div className="col-md-4 col-12 mt-2 mt-md-0">
                                <ToggleButtonGroup
                                    value={timeZone}
                                    exclusive
                                    onChange={(e, newTimeZone) => {setTimeZone(newTimeZone)}}
                                    aria-label="Time Zone"
                                >
                                    <ToggleButton value="Pacific Time" aria-label="Pacific Time">Pacific</ToggleButton>
                                    <ToggleButton value="Mountain Time" aria-label="Mountain Time">Mountain</ToggleButton>
                                    <ToggleButton value="Central Time" aria-label="Central Time">Central</ToggleButton>
                                    <ToggleButton value="Eastern Time" aria-label="Eastern Time">Eastern</ToggleButton>
                                </ToggleButtonGroup>
                            </div>
                        </div>
                        <div className="mb-3">
                            <div className="row">
                                <div className="col">
                                    <TextField
                                        select
                                        label="Region *"
                                        value={selectedRegion}
                                        className="w-100"
                                        onChange={(e) => setSelectedRegion(e.target.value)}
                                    >
                                        {regions.map((option) => (
                                            <MenuItem key={"r_" + option.regionId} value={option.regionId}>
                                                {option.regionName}
                                            </MenuItem>
                                        ))}
                                        {props.brandId === 3 ? ( <MenuItem value="real1031REMOTE">Real1031 Remote</MenuItem> ) : ( <MenuItem value="REMOTE">Remote</MenuItem>)}
                                    </TextField>
                                </div>
                                {selectedRegion === 'REMOTE' && props.brandId === 1 && <div className="col">
                                        <TextField
                                            select
                                            label="Class State"
                                            value={selectedClassState}
                                            className="w-100"
                                            onChange={(e) => setSelectedClassState(e.target.value)}
                                        >
                                        {Array.from(new Set((regions ?? []).filter(r => Number(r?.brandId) === 1).flatMap(r => (r?.stateAndCounties ?? []).map(sc => sc?.state)).filter(Boolean))).map((state) => (
                                            <MenuItem key={`s_${state}`} value={state}>
                                                {state}
                                            </MenuItem>
                                        ))}

                                        </TextField>
                                </div>}
                            </div>
                        </div>
                        {(((props.brandId === 1) && (selectedRegion === 9 || selectedRegion === 1)) || (selectedRegion === 'REMOTE' && (selectedClassState === "OR" || selectedClassState === "ID"))) && (
                                <div className="col mb-3">
                                    <TextField
                                        select
                                        label="Oregon Course Topic *"
                                        value={selectedCourseTopic}
                                        className="w-100"
                                        onChange={(e) => setSelectedCourseTopic(e.target.value)}
                                    >
                                        {["Real Estate Title", "Real Estate Escrow", "Real Estate Taxation", "Real Estate Economics", "Real Estate Finance"].map((topic, index) => (
                                            <MenuItem key={"topic_" + index} value={topic}>
                                                {topic}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </div>
                        )}
                        <div className="mb-3">
                            <TextField
                                select
                                label="Location"
                                value={selectedLocation}
                                className="w-100"
                                onChange={(e) => setSelectedLocation(e.target.value)}
                            >
                                {offices.filter(o => o.regionId === selectedRegion).map((option) => (
                                    <MenuItem key={"r_" + option.officeId} value={option.officeName}>
                                        {option.officeName} ({option.address1}, {option.city}, {option.stateAbbrev} {option.zip})
                                    </MenuItem>
                                ))}
                                <MenuItem value="Other">Other</MenuItem>
                            </TextField>
                        </div>
                        <div className={(selectedLocation === 'Other' || selectedRegion === 'REMOTE' || selectedRegion === 'real1031REMOTE') ? "mb-3" : "d-none"}>
                            <div className="row">
                                <div className="col">
                                    <Controller
                                        name="otherLocationName"
                                        control={control}
                                        rules={{ required: selectedLocation === 'Other' && selectedRegion !== 'REMOTE' && selectedRegion !== 'real1031REMOTE' }}
                                        render={({field})=>(
                                        <TextField
                                          {...field}
                                        label="Location Name"
                                        className="w-100"
                                        />
                                      )} />
                                    {selectedLocation === 'Other' && selectedRegion !== 'REMOTE' && selectedRegion !== 'real1031REMOTE' && errors?.otherLocationName?.type === "required" && <small className="text-danger">This field is required</small>}
                                </div>
                            </div>
                            {selectedLocation === 'Other' && selectedRegion !== 'REMOTE' && selectedRegion !== 'real1031REMOTE' && <><div className="row mt-2">
                                <div className="col">
                                    <TextField
                                        label="Address"
                                        {...register("otherLocationAddress")}
                                        className="w-100"
                                    />
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-5">
                                    <TextField
                                        label="City"
                                        {...register("otherLocationCity")}
                                        className="w-100"
                                    />
                                </div>                                   
                                <div className="col-3">
                                    <TextField
                                        label="State"
                                        {...register("otherLocationState", { required: selectedRegion !== 'REMOTE' && selectedRegion !== 'real1031REMOTE' })}
                                        className="w-100"
                                        inputProps={{ maxLength: 2 }}
                                    />
                                    {errors?.otherLocationState?.type === "required" && <small className="text-danger">This field is required</small>}
                                </div>                                
                                <div className="col-4">
                                    <TextField
                                        label="Zip"
                                        {...register("otherLocationZip")}
                                        className="w-100"
                                        inputProps={{ maxLength: 5 }}
                                    />
                                </div>
                            </div></>}
                        </div>
                        <div className="mb-3 d-flex gap-3">
                            <TextField
                                select
                                label="Certificate State *"
                                value={selectedCertificateState}
                                className="w-50"
                                onChange={(e) => setSelectedCertificateState(e.target.value)}
                            >
                                {Array.from(new Set((regions ?? []).filter(r => Number(r?.brandId) === 1).flatMap(r => (r?.stateAndCounties ?? []).map(sc => sc?.state)).filter(Boolean))).map((state) => (
                                    <MenuItem key={`s_${state}`} value={state}>
                                        {state}
                                    </MenuItem>
                                ))}

                            </TextField>
                            <TextField
                                label="Continuing Ed Credits"
                                {...register("contEdCredits", { pattern: /^\d+(\.\d)?$/ })}
                                className="w-50"
                                type="number"
                                inputProps={{ step: "0.1" }}
                            />
                            {errors?.contEdCredits?.type === "pattern" && <small className="text-danger">Use at most one decimal place (e.g., 1.5).</small>}
                        </div>
                        <div className="mb-3">
                            <TextField
                                label="Description"
                                {...register("description")}
                                className="w-100"
                                multiline
                                rows={5}
                            />
                        </div>
                        {props.brandId === 1 && (
                            <>
                                <div className="mb-3">
                                    <TextField
                                        label="Fee"
                                        {...register("fee")}
                                        className="w-100"
                                        helperText='If not filled in, "Fee Pending" will be indicated, and registration not allowed'
                                        type="number"
                                    />
                                </div>
                                <div className="mb-3">
                                    <div className="row">
                                        <div className="col">
                                            <TextField
                                                label="Discount Code"
                                                {...register("discountCode")}
                                                className="w-100"
                                                helperText='If discount code is not filled in, discount option will not be shown'
                                            />
                                        </div>
                                        <div className="col">
                                            <TextField
                                                label="Discounted Fee"
                                                {...register("discountedFee")}
                                                className="w-100"
                                                type="number"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <OutlinedDiv label="Confirmation Email Note">
                                        <Editor
                                            editorState={emailNoteEditorState}
                                            editorClassName="wysiwyg-title"
                                            onEditorStateChange={(e) => setEmailNoteEditorState(e)}
                                            />
                                    </OutlinedDiv>
                                </div>
                                <div className="mb-3">
                                    <TextField
                                        label="Instructor and Proctor Emails"
                                        {...register("notificationEmail")}
                                        className="w-100"
                                        helperText='These email addresses receive an email notification when someone registers. Separate by semi-colons (;).'
                                    />
                                </div>
                                <div className="mb-3">
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" id="requireRealEstateLicenseNum" {...register("requireRealEstateLicenseNum")}  />
                                        <label className="form-check-label" htmlFor="requireRealEstateLicenseNum">Require RE License Number</label>
                                    </div>
                                </div>
                                {requireLicense && (
                                    <div className="mb-3 ms-5">
                                        <label className="form-label me-3">Required License States:</label>
                                        <div className="d-flex gap-3 align-items-center flex-wrap">
                                            {["ID", "MT", "WA", "OR"].map((state) => (
                                                <div className="form-check form-switch" key={state}>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id={`state${state}`}
                                                        value={state}
                                                        checked={licenseStates.includes(state)}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            setLicenseStates((prev) =>
                                                                e.target.checked
                                                                    ? [...prev, value]
                                                                    : prev.filter((s) => s !== value)
                                                            );
                                                        }}
                                                    />
                                                    <label className="form-check-label" htmlFor={`state${state}`}>
                                                        {{
                                                            ID: "Idaho",
                                                            MT: "Montana",
                                                            WA: "Washington",
                                                            OR: "Oregon"
                                                        }[state]}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                <div className="mb-3">
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" id="requirePayment" {...register("requirePayment")}  />
                                        <label className="form-check-label" htmlFor="requirePayment">Require Credit Card Payment</label>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" id="isPrivate" {...register("isPrivate")}  />
                                        <label className="form-check-label" htmlFor="isPrivate">Private Class</label>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <TextField
                                        label="Max Registrants"
                                        {...register("maxRegistrants")}
                                        className="w-100"
                                        type="number"
                                    />
                                </div>
              
                            </>
                        )}
                    </div>
                    <div className="pt-2">
                        <button type="submit" className="btn btn-primary me-4">Submit</button>
                        <button type="button" className="btn btn-primary" onClick={() => { setClassIdToEdit(null); setClassToEdit(null); setSubmitted(false); setError(null); setSelectedLocation('Other'); setSelectedRegion(1); setTimeZone('Mountain Time'); setSelectedCourseTopic('Real Estate Title'); reset(); } }>Cancel</button>
                    </div>
                </form>
            </>
            :
            <>
                {submitted && <><div className="alert alert-success alert-dismissible" role="alert">Class saved successfully!<button type="button" className="btn-close" onClick={() => setSubmitted(false)} aria-label="Close"></button></div></>}
                {deleted &&  <div className="alert alert-warning alert-dismissible" role="alert">Class deleted successfully!<button type="button" className="btn-close" onClick={() => setDeleted(false)} aria-label="Close"></button></div>}
                {error && <div className="alert alert-danger" role="alert">{error}</div>}
                <div>
                    <DataGridPro
                        rows={classesToShow}
                        columns={columns}
                        loading={loadingClasses || registrantSearchLoading || classesToShow.length === 0}
                        filterModel={filterModel}
                        onFilterModelChange={handleFilterModelChange}
                        slotProps={{
                            loadingOverlay: {
                                variant: 'skeleton',
                                noRowsVariant: 'skeleton',
                            },
                            toolbar: {
                                onAddNewClass: handleAddNewClass,
                                registrantSearch: registrantSearch,
                                onRegistrantSearchChange: handleRegistrantSearchChange,
                                classesListType: classesListType,
                                onClassesListTypeChange: handleClassesListTypeChange,
                                quickFilterProps: {
                                    onKeyDown: blurOnEnterKey
                                }
                            }
                        }}
                        autoHeight
                        rowHeight={38}
                        disableRowSelectionOnClick
                        alignItems="center"
                        slots={{
                            toolbar: ClassesToolbar,
                        }}
                        initialState={{
                            pagination: {
                              paginationModel: { pageSize: 25, page: 0 },
                            },
                            columns: {
                                columnVisibilityModel: {
                                    registrantCount: width > 1000 ,
                                    location: width > 750 ,
                                    private: width > 500
                                }
                            },
                          }}
                        pagination
                        getDetailPanelContent={(params) => props.brandId !== 3 ? DetailPanelContent(params) : null}
                        getDetailPanelHeight={(params) => props.brandId !== 3 ? 'auto' : 0 }
                        onDetailPanelExpandedRowIdsChange={handleDetailPanelExpandedRowIdsChange}
                        detailPanelExpandedRowIds={expandedRowIds}
                        showToolbar />
                </div>
                
            </>
            }
            <div className="modal shown" tabIndex="-1" id="deleteModal" >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Delete Class?</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this class?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No, Cancel</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => deleteClass()}>Yes, Delete</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal shown" tabIndex="-1" id="deleteRegistrantModal" >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Delete Registrant?</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this registrant?</p>
                            {registrants.find(r => r.registrationId === classRegistrantIdToDelete)?.regTypeId === 1 && <p>The top waitlisted registrant will be added to the active class roster.</p>}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No, Cancel</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => deleteRegistrant()}>Yes, Delete</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal shown" tabIndex="-1" id="certificateModal" >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Class Certificates</h5>
                        </div>
                        <div className="modal-body">
                            {(!certificates || creatingCertificates) && <SpinnerLoader/>}
                            {!creatingCertificates && certificates && certificates.length > 0 &&
                                <div>
                                    <div className="row mb-2">
                                        <div className="col d-flex justify-content-center"><button type="button" className="btn btn-primary" disabled={certificatesAlreadyEmailed} onClick={() => emailCertificates(classCertificateId)}>Email</button></div>
                                        <div className="col d-flex justify-content-center"><button type="button" className="btn btn-primary" onClick={() => downloadCertificates(classCertificateId)}>Download All</button></div>
                                        <div className="col d-flex justify-content-center"><button type="button" className="btn btn-primary" onClick={() => createCertificates(classCertificateId)}>Recreate</button></div>

                                    </div> 
                                    <hr/>
                                    <ol>
                                        {certificates.map((cert, index) =>
                                            <li key={"cert_" + index}><a href={process.env.REACT_APP_FILES_BASE_URL.replace('public', cert)} target="_blank" rel="noreferrer">{cert.split('/')[cert.split('/').length - 1]}</a></li>
                                        )}
                                    </ol>
                                </div>}
                            {!creatingCertificates && certificates && certificates.length === 0 && <div>
                                    <p>Click the button below to create class certificates.</p>
                                    <button type="button" className="btn btn-primary" onClick={() => createCertificates(classCertificateId)}>Create Certificates</button>

                                </div>
                            }
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => {setCertificates(null); setClassCertificateId(0);}}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal shown" tabIndex="-1" id="relatedDocsModal" >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Related Documents</h5>
                        </div>
                        <div className="modal-body">
                            {gettingRelatedDocs && <SpinnerLoader/>}
                            <div className={gettingRelatedDocs ? "d-none" : ""}>
                                {!gettingRelatedDocs && relatedDocs.length > 0 &&
                                    <div className="pb-2">
                                        {relatedDocs.map((doc, index) =>
                                            <div className="row" key={"doc_" + index}>
                                                <div className="col-9" style={{textOverflow: "ellipsis", overflow: "hidden"} }>
                                                    <a style={{whiteSpace: "nowrap"}} href={process.env.REACT_APP_FILES_BASE_URL.replace('public', doc)} target="_blank" rel="noreferrer">{doc.split('/')[doc.split('/').length - 1]}</a>
                                                </div>
                                                <div className="col-3">
                                                    <button className="btn btn-link p-0" onClick={() => deleteDocument(doc) }><MdDelete title="Delete" /></button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                }
                                <OutlinedDiv label="Upload Related Docs">
                                    <div id="file" className="dropzone dropzone-previews border-0">
                                        <div className="dz-message" data-dz-message><span>{relatedDocs.length > 0 ? 'Files with the same name will be overwritten.' : 'Completed sign in sheet, evals, etc.'}</span></div>
                                    </div>
                                </OutlinedDiv>
                                <button type="button" className="btn btn-primary mt-3" onClick={() => downloadSignInSheet(relatedDocsId)}>Download Blank Sign in Sheet</button>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => { if (fileDropzone) {fileDropzone.destroy(); } setFileDropzone(null); setRelatedDocs([]); setRelatedDocsId(0)}}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Classes;
